import React, { Component } from 'react';
import Map from './Map';
import {  Icon, Grid } from 'semantic-ui-react';
import ShareModal from './components/ShareModal.tsx';
import 'semantic-ui-css/semantic.min.css';
// import LayerGroupAccordion from './components/LayerGroupAccordion'
// import MapSelector from "./components/mapSelector";
// import LoginModal from "./components/loginModal";
import {Modes, world, newZealand, RegionsByISO, StatesByRegion} from "./definitions";
// import Amplify from '@aws-amplify/core';
// import _config from './_config';
// import {isLoggedIn, loggedIn, logOut} from './providers/cognito';
// import {registerOnChange} from "./store/index";
// import ReactDOM from "react-dom";
// import config from './_config';

// function App() {
//   const [sidebar, setSidebar] = React.useState(0);
//   mapRef = React.createRef();
// Amplify.configure(_config.Auth);
const pipeHasDataFilter = [ "==",  ["typeof", [ "get", "heat_in_kw" ] ],  "number" ];
const pipeHasNoDataFilter = [ "!=",  ["typeof", [ "get", "heat_in_kw" ] ],  "number" ];
const pipeHasWidthFilter =  [ "!=", [ "get", "conduit_width" ], "0" ];
const itemIsNotPipeFilter =  [ "!=", [ "get", "link_type" ], "Cond" ];

// const itemIsNotPipeFilter =  [ false ];
class App extends Component {
  
    mapRef = React.createRef();
    
    callbacks = {};
    clickHandlers = {};
    
    state = {
        sidebar: 1,
        layerGroups: [],
        layers: [],
        mapStyleOptions: [],
        modeId: Modes.country,
        mode: "World",
        country: world,
        state: null,
        region: null,
        district: null,
        organisation: null,
        consent: null,
        activeMapStyle: {},
        loggedIn: false,
        userRegions: [],
        mapBusy: true,
        linkDecoded: false
    }
    
    dataChanged = (type, key, data) => {
        console.log("Type: " + type);
        console.log("Key: " + key);
        console.log("Data: " + data);
        this.setState({loggedIn: data});
    }

    userChanged = (type, key, data) => {
        console.log("Type: " + type);
        // console.log("Key: " + key);
        console.log( "USerData: ", data);
        var regionSelect = null;
        if(data ) {
            if(data.regions ){
                const theRegions = data.regions.split(",");
                console.log(theRegions);
                
                if(theRegions && theRegions.length === 1 && theRegions !== 'all') {
                    regionSelect = theRegions[0];
                    
                } else if ( theRegions === 'all' ) {
                    this.setState({userRegions: []},
                        this.setFiltersToUserRegions() );
                }
                this.setState({userRegions: theRegions},
                    this.setFiltersToUserRegions()
                    );

            }  else {
                this.setState({userRegions: []},
                    this.setFiltersToUserRegions() );
            }
            
            if(regionSelect) {
                console.log("Select: " , RegionsByISO[regionSelect]);
                this.setState({region: RegionsByISO[regionSelect]}, 
                    this.setModeRegion()
                 );

            }
        }
    }
    goToLink = () => {
        if(!this.state.mapBusy && !this.state.linkDecoded) {
            let loginParams = unescape(window.location.hash.substring(1));
            let decodedParams = loginParams;
            let parsedParams = {};
            if(loginParams) {
                console.log(loginParams );
                if(!loginParams.startsWith('{') && !loginParams.startsWith('[')) {
                    decodedParams = base64Decode( loginParams);
                    console.log("Base 64 decode");
                }
                try {
                    parsedParams = JSON.parse(decodedParams);
                }  catch (err) {
                    // printMessage(err, messageLevels.error);
                    return
                }
                // printData(parsedParams,messageLevels.verbose);
                const {level, selected, lat, lng, zoom, bounds, pitch, bearing } = parsedParams;
                
                window.history.replaceState(null, null, ' ');
                if(level && selected) {
                    switch (level) {
                        case "region" :
                            const theRegion = RegionsByISO[selected];
                            // console.log(theRegion)
                            if(theRegion) {
                                console.log("Setting region: ", theRegion)
                                console.log("Setting modeId: ", level)
                                this.setState({region: theRegion, modeId: level}, () =>
                                    this.setModeRegion()
                                );
                            }
                            break;
                        default:
                            //Do Nothing
                        break;
                        // case "city" :
                        //     const theRegion = RegionsByISO[selected];
                        //     // console.log(theRegion)
                        //     if(theRegion) {
                        //         console.log("Setting city: ", theRegion)
                        //         console.log("Setting modeId: ", level)
                        //         this.setState({region: theRegion, modeId: level}, () =>
                        //             this.setModeRegion()
                        //         );
                        //      }
                        //      break;
                    }
                }
                console.log("lng ", lng)
                console.log("lat ", lat)
                if(typeof lat !== 'undefined' && typeof lng !== 'undefined') {
                    // move to lat/lng /zoom
                    console.log("flying to: ", lng, lat);
                    this.mapRef.current.flyTo({
                        // These options control the ending camera position: centered at
                        // the target, at zoom level 9, and north up.
                        center: [lng, lat],
                        zoom: zoom || 9,
                        bearing: bearing || 0,
                        pitch: pitch || 0,
                        
                        // These options control the flight curve, making it move
                        // slowly and zoom out almost completely before starting
                        // to pan.
                        speed: 3, // make the flying slow
                        curve: 1, // change the speed at which it zooms out
                        
                        // This can be any easing function: it takes a number between
                        // 0 and 1 and returns another number between 0 and 1.
                        easing: (t) => {return Math.sin(t * Math.PI/2)},
                        
                        // this animation is considered essential with respect to prefers-reduced-motion
                        essential: false
                        });
                    

                } else if(bounds) {
                    // move to lat/lng /zoom
                    this.mapRef.current.zoomToBounds(bounds);
                }
                this.setState({linkDecoded: true});
            }
        }
    }
    setFiltersToUserRegions = () => {
        this.setFilters();
        // console.log(this.state.userRegions)
        // if(this.state.userRegions && this.state.userRegions.length > 0 && this.state.userRegions[0] !== "all") {
        //     this.setLayerFilter("regional-boundaries-line",['match', ['get', 'iso'],  this.state.userRegions,true,false]);
        //     this.setLayerFilter("regional-boundaries-line-dark",['match', ['get', 'iso'],  this.state.userRegions,true,false]);
        // } else {
        //     this.setLayerFilter("regional-boundaries-line",null);
        //     this.setLayerFilter("regional-boundaries-line-dark",null);
        // }
        
    }

    setMaxBounds = (bounds) => {
        
        if(this.mapRef && typeof this.mapRef !== undefined) {
            this.mapRef.current.setMaxBounds(bounds);
        }
    }

    setupMode = () => {
        console.log("Setup Mode: " + this.state.modeId);
        switch (this.state.modeId) {
            case Modes.country:
                this.setModeCountry();
                break
            case Modes.state:
                this.setModeState();
                break
            case Modes.region:
                this.setModeRegion();
                break
            case Modes.consent:
                this.setModeCity();
                break
            default:
                console.log("no state set")
                
        }
        this.goToLink ();
    }
    // handleLogOut = async () => {
    //     logOut();
    //     this.setState({loggedIn: await loggedIn()});
    // }
    setMapStyleOptions = (mapStyleOptions) => {
        // console.log("setMapStyleOptions: " + mapStyleOptions);
        this.setState({mapStyleOptions: mapStyleOptions}, 
           () => { this.setupMode()}
        );
    };

    changeMapState = (mapStyle) => {
        this.setState({activeMapStyle: mapStyle});
        if(this.mapRef && typeof this.mapRef !== undefined) {
            this.mapRef.current.changeMapState(mapStyle);
            
        }
    };
    
    setLayerGroups = (layerGroups) => {
        this.setState({layerGroups: layerGroups});
    };

    setLayers = (layers) => {
        this.setState({layers: layers});
    };

    getLayerVisibility = (layerName) => {
        if(this.mapRef && typeof this.mapRef !== undefined) {
            
            const theVisibility = this.mapRef.current.getLayerVisibility(layerName);
            // console.log("App: " + theVisibility);
            return theVisibility;
        }
        console.log("no map");
       return "";
    };

    setLayerVisibility = (layerName, visibility) => {
        // console.log("Setting: " + layerName + " to: "+ visibility);
        // console.log(this.mapRef);
        if(typeof this.mapRef !== 'undefined' && typeof this.mapRef.current !== 'undefined' &&  this.mapRef.current) {
            this.mapRef.current.setLayerVisibility(layerName, visibility);
        }
    };

    setLayerFilter = (layerName, filter) => {
        // console.log("Setting: " + layerName + " to: "+ filter);

        if(typeof this.mapRef !== 'undefined' && typeof this.mapRef.current !== 'undefined' &&  this.mapRef.current) {
            this.mapRef.current.setFilter(layerName, filter);
        }
    };

    zoomToFeature = (feature) => {
        if(typeof this.mapRef !== 'undefined' && typeof this.mapRef.current !== 'undefined' &&  this.mapRef.current) {
            return this.mapRef.current.zoomToFeature(feature);
        }
        
    };

    setModeCity = (layerId, feature) => {
        var levelData = null;
        var theRegion = null;
        var theState = null;
        if(feature) {
            const properties =  feature.properties;
            // console.log(properties);
            const consent = {id: feature.properties.consent_number, label: feature.properties.forest_name, view: {lat: -40.9588, lng: 172.4874, zoom: 9,
                "bearing": 0,
                "pitch": 0}}
                this.setState({consent: consent});
                // this.mapRef.current.setCityId(consent.id);
                
            // this.setLayerFilter("forest-blocks-line",['==', consent.id, ['get', 'consent_number']]);
            // this.setLayerFilter("forest-blocks-fill",['==', consent.id, ['get', 'consent_number']]);
            levelData = consent;
            theRegion = properties.region;
            levelData = RegionsByISO[theRegion];
            theState = StatesByRegion[theRegion];
            
        }
        // console.log(layerId);
        this.setState({mode: "city", modeId: Modes.city, state: theState, region: theRegion, city: null}, () => { this.setFilters()});
    
        this.setState({modeId: Modes.city});
        this.setState({state: theState});

        this.setState({mode: "city"});

        this.handleBounds(feature, levelData);
    };

    setModeRegion = (layerId, feature) => {
        if(this.state.modeId !== Modes.region || (feature && feature.properties && this.state.region &&feature.properties.iso !== this.state.region.idISO) ){
            console.log(layerId);

            var levelData = null;
            var theRegion = null;
            var theState = null;
            if(feature) {

                theRegion = feature.properties.iso
                // theRegionISO = feature.properties.
                console.log ("Feature Region: ", theRegion);
                levelData = RegionsByISO[theRegion];
                theState = StatesByRegion[theRegion];
            } else {
                levelData = this.state.region;
                console.log(levelData);
                if(levelData.state) {
                    theState = levelData.state;
                } else {
                    theState = StatesByRegion[theRegion];
                }
                
            }
        
            console.log({mode: "region", modeId: Modes.region, state: theState, region: levelData, city: null});
            this.setState({mode: "region", modeId: Modes.region, state: theState, region: levelData, city: null}, () => { this.setFilters()});

            this.handleBounds(feature, levelData);
        }
    };
    getModeParams = () => {
        switch(this.state.mode) {
            case "region":
                return {level: this.state.mode, selected: this.state.region.idISO};
            case "country":
                return {level: this.state.mode, selected: "NZ"};
            default:
                //Do Nothing
                break;
        }
        
     return {};
    }
    getViewParams = () => {
        if(typeof this.mapRef !== 'undefined' && typeof this.mapRef.current !== 'undefined' &&  this.mapRef.current) {
            return this.mapRef.current.getViewParams();
        }
        return {};
    }
    setModeState = (layerId, feature) => {
        console.log(layerId);
        var levelData = null;
        // var theState = null;
        if(feature) {

           
        } else {
            levelData = this.state.state;
        }
        // this.mapRef.current.setCityId(null);
        this.setState({mode: "state", modeId: Modes.state, region: null, consent: null},  () => { this.setFilters()});
      
       
        
       
        // this.setFiltersToUserRegions();
       
      
  

        this.handleBounds(feature, levelData);
    };

    setFilters = ( ) => {
        console.log("Set filters");
        if(this.state.mapBusy ) {
            console.log("map is busy");
        } else {
            this.goToLink();
        
        console.log("Region: "+ this.state.region);
        if (this.state.region ) {
            
            const theRegion = this.state.region.idISO;
            console.log("Region iso: "+ theRegion);
            this.setLayerFilter("regional-boundaries-line",['==', theRegion, ['get', 'iso']]);
            this.setLayerFilter("regional-boundaries-line-dark",['==', theRegion, ['get', 'iso']]);


            this.setLayerFilter("pipes", ["all" , pipeHasWidthFilter, pipeHasDataFilter ,['==', theRegion, ['get', 'regions']]]);
            this.setLayerFilter("nodes", ["all" , itemIsNotPipeFilter ,['==', theRegion, ['get', 'regions']]]);
    
            this.setLayerFilter("pipes-nodata", ["all" , pipeHasWidthFilter, pipeHasNoDataFilter,['==', theRegion, ['get', 'regions']]] );
            this.setLayerFilter("clicklayer", ['==', theRegion, ['get', 'regions']] );

            this.setLayerFilter("regional-boundaries-fill",['!=', theRegion, ['get', 'iso']]);
            this.setLayerFilter("regional-boundaries-shade",['!=', theRegion, ['get', 'iso']]);
            this.setLayerVisibility("pipes",true);
            this.setLayerVisibility("nodes",true);
            this.setLayerVisibility("pipes-nodata",true);
            this.setLayerVisibility("clicklayer",true);
            this.setLayerVisibility("regional-boundaries-shade",true);
            // this.setLayerVisibility("regional-boundaries-fill",false);
        } else {
            console.log("No region");
            this.setLayerVisibility("regional-boundaries-fill",true);
            this.setLayerVisibility("pipes",true);
            this.setLayerVisibility("nodes",true);
            this.setLayerVisibility("pipes-nodata",true);
            this.setLayerVisibility("clicklayer",true);

            this.setLayerFilter("regional-boundaries-line",null);
            this.setLayerFilter("regional-boundaries-line-dark",null);

            this.setLayerFilter("pipes", ["all" , pipeHasWidthFilter , pipeHasDataFilter]);
            this.setLayerFilter("nodes",  itemIsNotPipeFilter);
            this.setLayerFilter("pipes-nodata", ["all" , pipeHasWidthFilter , pipeHasNoDataFilter] );
            this.setLayerFilter("clicklayer", null );
            this.setLayerFilter("regional-boundaries-fill",null);
            this.setLayerVisibility("regional-boundaries-shade",false);
        }
    }
    }
    
    handleBounds = (feature, levelData) => {
        if(feature && typeof feature !== 'undefined' ) {
            console.log("localising feature: " + feature);
            this.zoomToFeature(feature);
            const bounds = this.zoomToFeature(feature);
            if(bounds){
                this.setMaxBounds(bounds);
            }
            if(levelData && !levelData.bounds && bounds) {
                console.log("Storing boounds: " + bounds);
                levelData.bounds = bounds;
            }
        } else {
            if( levelData && levelData.bounds) {
                console.log("Using stored bounds: " + levelData.bounds);
                if(this.mapRef.current) {
                    this.mapRef.current.zoomToBounds(levelData.bounds);
                    this.setMaxBounds(levelData.bounds);
                }
            } else if( levelData && levelData.view) {
                console.log("Using stored view: " + levelData.view);
                if(this.mapRef.current) {
                    this.mapRef.current.zoomToView(levelData.view);
                }
                
            } 
            
        }
    }

    setModeCountry = (layerId, feature) => {
        console.log("Country: " + layerId);
        var levelData = null;
        if(feature) {
            levelData = newZealand;
            this.setState({country: levelData})
        } else {
            levelData = this.state.country;
        }
        this.setState({mode: "country", modeId: Modes.country, country: newZealand, state: null, consent: null ,region: null},  () => { this.setFilters()});
       
        this.handleBounds(feature, levelData);
    };
    /***
     * functions to be called as click handlers
     * 
     */
    clickHandlers = {
        setModeCity: this.setModeCity,
        setModeRegion: this.setModeRegion,
        setModeState: this.setModeState,
        setModeCountry: this.setModeCountry
    };
   
    consentHeder = () => {
        if(this.state.consent) {
            return ( <div style={{padding: 10}}>
                <h3>{this.state.consent.label} ({this.state.consent.id})</h3>
                </div>);
        }
        else return (<></>);
    }
    regionHeder = () => {
        if(this.state.region) {
            if(false && this.state.region.logo ) {
                return (<Grid.Column><div style={{padding: 10}}>
                    <img src={this.state.region.logo} height="40px" alt={this.state.region.name + " logo"} onClick={() => {this.setModeRegion(null,null)}} ></img>
                    </div></Grid.Column>);
                } else {
                return (<Grid.Column onClick={() =>{this.setModeRegion(null,null)}}>
                    <h3>{this.state.region.label}</h3>
                    </Grid.Column>);
                }
        }
        else return (<></>);
    }
    stateHeder = () => {
        if(this.state.state) {
            if(this.state.state.logo ) {
                return (<Grid.Column><div style={{padding: 10}}>
                <img src={this.state.state.logo} height="38px" alt={this.state.state.name + " logo"} onClick={() => {this.setModeState(null,null)}} ></img>
                </div></Grid.Column>);
            } else {
            return (<Grid.Column onClick={() =>{this.setModeState(null,null)}} >
                <h3>{this.state.state.label}</h3>
                {/* <img src={this.state.region.logo} height="38px" alt={this.state.region.name + " logo"} onClick={() => {this.setModeRegion(null,null)}} ></img> */}
                </Grid.Column>);
            }
        }
        else return (<></>);
    }
    countryHeder = () => {
        if(this.state.country) {
            if(this.state.country.logo ) {
                return (<Grid.Column><div style={{padding: 9}}>
                <img src={this.state.country.logo} height="38px" alt={this.state.country.name + " logo"} onClick={() => {this.setModeCountry(null,null)}} ></img>
                </div></Grid.Column>);
            } else {
                return (<Grid.Column width="1"><div style={{padding: 15}} onClick={() =>{this.setModeCountry(null,null)}} >
                    <Icon name="home" size="large"></Icon>
            
                {/* <img src={this.state.region.logo} height="38px" alt={this.state.region.name + " logo"} onClick={() => {this.setModeRegion(null,null)}} ></img> */}
                </div></Grid.Column>);
            }
            
        }
        else return (<></>);
    }

    // logIn = () => {
    //     this.setState({loggedIn: loggedIn()});
    // }
    loginControl = () => {
        // var isIn = loggedIn()
       return (<></>);
        // if( this.state.loggedIn) {
        //     return (<button onClick={this.handleLogOut}>Log Out</button>);
        // } else {
        //     return ( <LoginModal></LoginModal> );
        // }
    }
    
    // componentDidMount = () => {
        // registerOnChange("loginState", this.dataChanged);
        // registerOnChange("userProfile", this.userChanged);
    // }
    mapIsLoaded = () => {
        this.setState({mapBusy: false}, () =>{ this.setFilters()});
    }

     /***
     * functions to be called inside app
     * as one object so can be passed as one parameter
     */
      callbacks = {
        mapIsLoaded: this.mapIsLoaded,
        setMapStyleOptions: this.setMapStyleOptions,
        setLayerGroups: this.setLayerGroups,
        setLayers: this.setLayers,
        getLayerVisibility: this.getLayerVisibility,
        setLayerVisibility: this.setLayerVisibility };


  render () {
    return(
        <>
            <div style={{ top: 55}}>
                <Map ref={this.mapRef} mode={this.state.mode} callbacks={this.callbacks} setLayerGroups={this.setLayerGroups} setLayers={this.setLayers} clickHandlers={this.clickHandlers} />
                <div className='menu_container'>
                    <ShareModal getModeParams={this.getModeParams} getViewParams={this.getViewParams}></ShareModal>    
                </div>
            </div>
        </>
    )
    };
}

export default App;
function base64Decode (data) {
    let text = "";
  if (typeof data !== 'undefined') {
    try {
      let buff = Buffer.from(data, 'base64');
      text = buff.toString('ascii');
    } catch (err) {
        // printMessage(err, messageLevels.error);
    //   reportError(err);
    }
    return text;
  }
  return "";
}